<template>
  <modal-wrapper
    :size="size"
    :open="open"
    :modal-class="$style.modal"
    :content-class="$style.content"
    @change="handleChange"
  >
    <template #before>
      <transition
        appear
        :enter-from-class="$style.transitionStart"
        :enter-active-class="$style.transitionShow"
        :leave-active-class="$style.transitionHide"
        :leave-to-class="$style.transitionStart"
      >
        <div
          v-show="open"
          :class="$style.background"
        >
          <ai-background />
        </div>
      </transition>
    </template>
    <template #default="{ hide, dismiss, setDirty }">
      <transition
        appear
        :enter-from-class="$style.transitionStart"
        :enter-active-class="$style.transitionShow"
        :leave-active-class="$style.transitionHide"
        :leave-to-class="$style.transitionStart"
      >
        <div
          :class="[$style.main, { [$style.transition]: transitioning }]"
          :style="{ height: dynamicHeight }"
        >
          <div
            ref="body"
            :class="$style.body"
          >
            <transition
              :enter-from-class="$style['delay-enter-from']"
              :enter-active-class="$style['delay-enter-active']"
              :leave-active-class="$style['delay-leave-active']"
              :leave-to-class="$style['delay-leave-to']"
              mode="out-in"
            >
              <div :key="`${transitionKey}`">
                <slot
                  :transitioning="transitioning"
                  :hide="hide"
                  :dismiss="dismiss"
                  :set-dirty="setDirty"
                />
              </div>
            </transition>
          </div>
        </div>
      </transition>
    </template>
  </modal-wrapper>
</template>

<script setup lang="ts">
// анимации исчезновения не работают
import { onMounted, ref, useTemplateRef, watch } from 'vue';
import { useResizeObserver } from '@vueuse/core';
import ModalWrapper from '@/shared/legacy/ui/modal-next/modal-wrapper.vue';
import AiBackground from '../ai-background/ai-background.vue';

const { open = true, size = 'default', transitionKey } = defineProps<{
  open?: boolean;
  transitionKey?: string;
  size?: 'default' | 'wysiwyg';
}>();

const emit = defineEmits<{
  (e: 'close'): void;
}>();

function handleChange(flag) {
  if (!flag) {
    emit('close');
  }
}

// Height transition

const body = useTemplateRef('body');
const dynamicHeight = ref('');

onMounted(() => {
  setTimeout(() => {
    useResizeObserver(body.value, (entries) => {
      const entry = entries[0];
      const { height } = entry.contentRect;
      dynamicHeight.value = `${height}px`;
    });
  }, 500);
});

// Fade transition
const transitioning = ref(false);

watch(() => transitionKey, () => {
  transitioning.value = true;
  setTimeout(() => {
    transitioning.value = false;
  }, 300);
});
</script>

<style module>
.modal {
  top: 64px;
  bottom: 8px;
}
.content {
  margin-top: 66px;
  transition: width .3s ease-in-out;
}
.background {
  position: fixed;
  inset: 64px 8px 8px;
  pointer-events: none;
}
.transitionShow {
  transition: all 0.5s cubic-bezier(0.25, 0.1, 0.25, 1);
}
.transitionHide {
  transition: all 0.3s cubic-bezier(0.25, 0.1, 0.25, 1);
}
.transitionStart {
  transform: scale(1.2);
  opacity: 0;
}

.main {
  border-radius: var(--Radius-x4, 16px);
  position: relative;
  background: $white;

  &::before{
    content: '';
    width: 100%;
    height: calc(100% - 80px);
    top: 80px;
    background: $white;
    position: absolute;
    opacity: 0;
    z-index: 10000;
    pointer-events: none;
    transition: 0.15s;
  }
}

.body{
  background: $white;
  border-radius: var(--Radius-x4, 16px);
}

.transition {
  transition: height 0.3s;
  overflow: hidden;
  &::before {
    opacity: 1;
  }
}

@keyframes delay {
  from{
  }
  to{
  }
}

.delay-enter-active,
.delay-leave-active {
  animation: delay 0.15s;
}
</style>

<i18n lang="json">{}</i18n>
